import { legacy_createStore as createStore, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import RootReducer from "../reducers/RootReducer";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function ConfigureStore() {
  return createStore(RootReducer, undefined, composeEnhancers(applyMiddleware(thunk)));
}

export type AppDispatch = ReturnType<typeof ConfigureStore>["dispatch"];
